/** @format */

import {
	AppProductReviewState,
	selectProductReviewProductIdentifier
} from '@product-reviews/data-access';

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerComponent } from '@shared/components';
import { Store } from '@ngrx/store';

@Component({
	selector: 'product-reviews-questions-answers',
	templateUrl: './review-questions-and-answers.component.html',
	styleUrl: './review-questions-and-answers.component.scss',
	imports: [CommonModule, ProgressSpinnerComponent]
})
export class ReviewQuestionsAndAnswersComponent {
	/**
	 *
	 * @description
	 * Product Id - Bazaar voice uses this identifier to display the correct reviews
	 */
	productIdentifier$ = this.store.select(selectProductReviewProductIdentifier);

	constructor(private store: Store<AppProductReviewState>) {}
}
